<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <div>
              <h1 class="text-center">Erro 404!</h1>
              <h4 class="text-center">Página não encontra!</h4>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'not-found',
  metaInfo: {
    title: 'Página não encontra',
    // all titles will be injected into this template
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
};
</script>
